import { useMember } from "../../context/memberContext";
import { useTranslations } from "../../hooks/useTranslations";
import { SP } from "../../http/serviceportalApi";
import { I18N } from "../../i18n/de";
import DepartmentApps from "../DepartmentApps";
import { DOCUMENTS_LIST_ID } from "../documents/DocumentsList";
import { getAuthorizedLuidsByDocumentSet } from "../documents/utils";
import Page from "../ui/Page";
import PageSection from "../ui/PageSection";
import QuickAccess, { QuickAccessItemProps } from "../ui/QuickAccess";

const Accounting = () => {
  const { i18n } = useTranslations();
  const { member } = useMember();
  const quickAccessItems = member ? getQuickAccessItems(member, i18n) : [];

  return (
    <Page
      title={i18n.departments.accounting.title}
      description={i18n.departments.accounting.description}
    >
      {quickAccessItems.length > 0 && (
        <PageSection title={i18n.nav.quickAccess}>
          <QuickAccess items={quickAccessItems} />
        </PageSection>
      )}
      <PageSection title={i18n.nav.apps}>
        <DepartmentApps department="accounting" />
      </PageSection>
    </Page>
  );
};

const quickAccessDocumentSets: SP.DocumentSetType[] = ["steuer-rundschreiben"];

const getQuickAccessItems = (member: SP.Member, i18n: I18N) => {
  return quickAccessDocumentSets.reduce(
    (state: QuickAccessItemProps[], value) => {
      if (getAuthorizedLuidsByDocumentSet(member, value).length > 0) {
        const props: QuickAccessItemProps = {
          name: i18n.documentSet[value],
          type: "documents",
          to: `/dokumente/steuerberatung/${value}#${DOCUMENTS_LIST_ID}`,
        };
        return [...state, props];
      }
      return state;
    },
    [],
  );
};

export default Accounting;
